import { isUrl } from '@albacross/frontend-utils'

export const customerEditValidator = (values: any) => {
  const errors: Record<string, string> = {}

  if (!values.name) {
    errors.name = 'Name is required'
  } else if (values.name.length < 3 || values.name.length > 250) {
    errors.name = 'Name must be between 3 and 250 characters'
  }

  if (!values.website) {
    errors.website = 'Website is required'
  } else if (!isUrl(values.website.toLowerCase())) {
    errors.website = 'Website is invalid'
  }

  if (values.tier != null && values.tier !== '') {
    const tier = Number(values.tier)
    if (!Number.isInteger(tier) || tier < 1 || tier > 9) {
      errors.tier = 'Tier must be between 1 and 9'
    }
  }

  return errors
}
